import * as yup from "yup";
import { DEFAULT_MESSAGES } from "../defaultMessages";

const notOnlySpacesAndRequiresAlphaNumeric = yup
  .string()
  .required(DEFAULT_MESSAGES.REQUIRED)
  .test(
    "is-not-blank",
    "Este campo no puede estar vacío o contener solo espacios.",
    value => !!value && value.trim().length > 0 && /[A-Za-z0-9]/.test(value)
  );
const alphaNumericOrEmpty = yup
  .string()
  .test(
    "is-valid",
    "Este campo no puede contener solo espacios y debe tener letras o números.",
    value => {
      if (!value) return true; // si está vacío, OK porque no es requerido
      return value.trim().length > 0 && /[A-Za-z0-9]/.test(value);
    }
  );

export const createEspaciosCurricularesSchema = yup.object({
  nombre: notOnlySpacesAndRequiresAlphaNumeric,

  descripcion: yup.string().optional(),

  tipo_espacio_id: yup.number().required(DEFAULT_MESSAGES.REQUIRED),

  area_id: yup.number().required(DEFAULT_MESSAGES.REQUIRED),

  anio: yup
    .number()
    .required(DEFAULT_MESSAGES.REQUIRED)
    .min(1, "El año debe ser mayor a 0"),

  nivel_id: yup.number().required(DEFAULT_MESSAGES.REQUIRED),


  horas_semanales: yup
    .number()
    .required(DEFAULT_MESSAGES.REQUIRED)
    .min(1, "Las horas semanales deben ser mayores a 0"),

  espacio_formacion: alphaNumericOrEmpty,

  sub_tipo: yup.string().when("con_sub_tipo", (_, schema, data) => {
    if (data.context.con_sub_tipo) {
      return yup.string().required(DEFAULT_MESSAGES.REQUIRED);
    }
    return yup.mixed().notRequired();
  }),

  ciclo_id: yup.number(),
});
